module.exports = "/images/regel-4.jpg?9eb2d21080476ef6f9cf40251b5a112a";